/**
 * JSON-LD structured data for CRAFTFINDUS
 */

const BASE_URL = "https://www.craftfindus.com";

const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "CRAFTFINDUS",
  url: BASE_URL,
  logo: `${BASE_URL}/og-image.png`,
  description:
    "CRAFTFINDUS ist eine B2B-Plattform, die Auftraggeber mit qualifizierten Handwerksbetrieben verbindet. Kostenlos für Suchende, vorqualifizierte Projektanfragen für Handwerker.",
  sameAs: [],
  founder: {
    "@type": "Person",
    name: "Alexander Wolfshohl",
    jobTitle: "Gründer & Geschäftsführer",
  },
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+49-212-24355800",
      email: "kontakt@craftfindus.de",
      contactType: "customer service",
      availableLanguage: ["German", "English"],
      areaServed: ["DE", "AT", "CH"],
    },
    {
      "@type": "ContactPoint",
      telephone: "+49-212-24355830",
      email: "kontakt@craftfindus.de",
      contactType: "sales",
      availableLanguage: ["German"],
      areaServed: ["DE", "AT", "CH"],
    },
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Mittelpilghausen 20",
    addressLocality: "Solingen",
    postalCode: "42657",
    addressCountry: "DE",
    addressRegion: "NRW",
  },
  areaServed: [
    { "@type": "Country", name: "Germany" },
    { "@type": "Country", name: "Austria" },
    { "@type": "Country", name: "Switzerland" },
  ],
  knowsAbout: [
    "Handwerksvermittlung",
    "Elektriker finden",
    "Sanitär Handwerker",
    "Heizungsinstallateur",
    "Dachdecker",
    "Photovoltaik Installation",
    "Innenausbau",
    "Malerbetrieb",
    "Bauunternehmen",
    "Klimaanlagen",
    "Schreiner",
    "Fensterbauer",
    "Gartenbau",
    "Handwerker Projektanfragen",
    "Handwerker Leads",
  ],
};

const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "CRAFTFINDUS",
  alternateName: "CRAFT FINDUS",
  url: BASE_URL,
  description:
    "CRAFTFINDUS verbindet Auftraggeber mit den passenden Handwerksbetrieben. Kostenlos Handwerker finden oder als Betrieb qualifizierte Projektanfragen erhalten.",
  inLanguage: ["de-DE", "en", "nl", "fr", "pl"],
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: `${BASE_URL}/suche`,
    },
    "query-input": "required name=search_term_string",
  },
};

const SERVICE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Handwerker-Vermittlung",
  alternateName: ["Handwerksbetrieb finden", "Handwerker suchen", "Craft matching platform"],
  provider: {
    "@type": "Organization",
    name: "CRAFTFINDUS",
    url: BASE_URL,
  },
  description:
    "Kostenlos den passenden Handwerksbetrieb finden: Elektriker, Sanitär, Dachdecker, Maler und mehr. CRAFTFINDUS matcht Ihre Projektanfrage intelligent mit 3 bis 5 qualifizierten Betrieben in Ihrer Region.",
  serviceType: "Handwerker-Vermittlung",
  category: "Vermittlungsservice",
  audience: {
    "@type": "BusinessAudience",
    audienceType: "Immobilienbesitzer, Hausverwaltungen und Unternehmen",
  },
  areaServed: [
    { "@type": "Country", name: "Germany" },
    { "@type": "Country", name: "Austria" },
    { "@type": "Country", name: "Switzerland" },
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Gewerke-Kategorien",
    itemListElement: [
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Elektriker finden", description: "Elektroinstallation, Smart Home, Beleuchtung, Sicherungskästen" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Sanitär & Heizung", description: "Bad-Renovierung, Heizungsaustausch, Rohrleitungen, Wärmepumpen" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Dachdecker & Zimmerer", description: "Dachsanierung, Dachfenster, Dachabdichtung, Dachstuhl" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Photovoltaik & Klima", description: "Solaranlagen, Wärmepumpen, Klimaanlagen, Energieberatung" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Maler & Bodenleger", description: "Fassade, Tapezieren, Trockenbau, Bodenbeläge, Innenausbau" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Bauunternehmen", description: "Neubau, Komplettsanierung, Fliesenarbeiten, Trockenbau" } },
      { "@type": "Offer", itemOffered: { "@type": "Service", name: "Schreiner & Fensterbauer", description: "Möbelbau, Fenster, Türen, Holzarbeiten" } },
    ],
  },
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "EUR",
    description: "Kostenlos für Auftraggeber – keine Gebühren, keine Provisionen",
  },
};

const FAQ_ITEMS = [
  // Für Auftraggeber
  {
    question: "Ich brauche einen Handwerker, weiß aber nicht genau welches Gewerk. Ist CRAFTFINDUS das Richtige?",
    answer:
      "Ja, absolut! CRAFTFINDUS ist genau dafür gemacht. Beschreiben Sie einfach Ihr Projekt in der geführten Anfrage – wir finden das passende Gewerk und die richtigen Betriebe für Sie. Komplett kostenlos.",
  },
  {
    question: "Was kostet es, wenn ich einen Handwerker suche?",
    answer:
      "Für Sie als Auftraggeber ist CRAFTFINDUS komplett kostenlos. Sie stellen Ihre Projektanfrage, erhalten 3 bis 5 passende Handwerksbetriebe und entscheiden selbst, mit wem Sie zusammenarbeiten. Keine versteckten Kosten.",
  },
  {
    question: "Wie schnell bekomme ich Antworten auf meine Projektanfrage?",
    answer:
      "In der Regel melden sich qualifizierte Handwerksbetriebe innerhalb von 24 Stunden bei Ihnen. Bei dringenden Anfragen oft sogar schneller. Sie erhalten maximal 3 bis 5 Angebote – handverlesen, keine Massenantworten.",
  },
  {
    question: "Welche Projekte kann ich über CRAFTFINDUS anfragen?",
    answer:
      "Praktisch alle Handwerksprojekte: Elektroinstallation, Sanitär, Heizung, Dach, Innenausbau, Photovoltaik, Klimaanlagen, Malerarbeiten und vieles mehr. Egal ob kleine Reparatur oder großes Bauprojekt.",
  },
  {
    question: "In welchen Regionen ist CRAFTFINDUS verfügbar?",
    answer:
      "CRAFTFINDUS ist in ganz Deutschland, Österreich und der Schweiz verfügbar. Wir erweitern unser Handwerker-Netzwerk stetig, um in jeder Region die besten Betriebe anbieten zu können.",
  },
  // Für Handwerksbetriebe
  {
    question: "Was bringt mir CRAFTFINDUS als Handwerksbetrieb?",
    answer:
      "Sie erhalten vorqualifizierte Projektanfragen, die zu Ihrem Gewerk und Ihrer Region passen. Maximal 3 bis 5 Betriebe pro Anfrage bedeutet: weniger Wettbewerb, höhere Abschlussquoten, kein Preiskampf.",
  },
  {
    question: "Wie funktioniert das Matching bei CRAFTFINDUS?",
    answer:
      "Unser Algorithmus analysiert jede Projektanfrage und gleicht sie mit Ihrem Profil ab: Gewerk, Spezialisierung, Region, Verfügbarkeit und Projektgröße. Nur bei hoher Passung erhalten Sie die Anfrage.",
  },
  {
    question: "Was kostet CRAFTFINDUS für Handwerksbetriebe?",
    answer:
      "Sie zahlen nur pro angenommener Projektanfrage einen transparenten, festen Preis. Keine monatlichen Gebühren, keine Provisionen auf Ihre Aufträge. Sie entscheiden selbst, welche Projekte Sie annehmen.",
  },
  {
    question: "Was unterscheidet CRAFTFINDUS von anderen Handwerker-Portalen?",
    answer:
      "Kein Bieten, kein Preisdumping, keine Vergleichsportal-Mechanik. Bei CRAFTFINDUS werden Handwerksbetriebe ausgewählt, nicht gesucht. Die Limitierung auf 3 bis 5 Betriebe pro Anfrage sichert faire Chancen.",
  },
  {
    question: "Gibt es eine Vertragsbindung bei CRAFTFINDUS?",
    answer:
      "Nein. Sie können CRAFTFINDUS jederzeit ohne Kündigungsfrist verlassen. Keine Mindestlaufzeit, keine versteckten Kosten. Sie behalten volle Kontrolle über Ihr Anfragen-Volumen.",
  },
];

const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ_ITEMS.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
};

const HOWTO_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "HowTo",
  name: "Handwerker finden mit CRAFTFINDUS",
  description: "In 3 einfachen Schritten den passenden Handwerksbetrieb finden – kostenlos und unkompliziert.",
  totalTime: "PT5M",
  estimatedCost: {
    "@type": "MonetaryAmount",
    currency: "EUR",
    value: "0",
  },
  step: [
    {
      "@type": "HowToStep",
      name: "Projekt beschreiben",
      text: "Beantworten Sie ein paar einfache Fragen zu Ihrem Handwerksprojekt – z.B. Gewerk, Projektart, Standort und Budget.",
      url: `${BASE_URL}/inquiry`,
      position: 1,
    },
    {
      "@type": "HowToStep",
      name: "Handwerker werden ausgewählt",
      text: "CRAFTFINDUS findet automatisch 3 bis 5 Handwerksbetriebe, die zu Ihrem Projekt passen – aus Ihrer Region, mit der richtigen Erfahrung.",
      position: 2,
    },
    {
      "@type": "HowToStep",
      name: "Angebote erhalten",
      text: "Die ausgewählten Betriebe melden sich innerhalb von 24 Stunden direkt bei Ihnen. Sie entscheiden, wer am besten passt.",
      position: 3,
    },
  ],
};

const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "CRAFTFINDUS",
  url: BASE_URL,
  logo: `${BASE_URL}/og-image.png`,
  image: `${BASE_URL}/og-image.png`,
  telephone: "+49-212-24355800",
  email: "kontakt@craftfindus.de",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Mittelpilghausen 20",
    addressLocality: "Solingen",
    postalCode: "42657",
    addressCountry: "DE",
    addressRegion: "Nordrhein-Westfalen",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: "51.1657",
    longitude: "7.0834",
  },
  priceRange: "Kostenlos für Auftraggeber",
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "08:00",
    closes: "18:00",
  },
};

interface JsonLdProps {
  includeFaq?: boolean;
  includeService?: boolean;
  includeHowTo?: boolean;
  includeLocalBusiness?: boolean;
  breadcrumbs?: { name: string; url: string }[];
  customSchemas?: object[];
}

export default function JsonLd({
  includeFaq = false,
  includeService = false,
  includeHowTo = false,
  includeLocalBusiness = false,
  breadcrumbs,
  customSchemas,
}: JsonLdProps) {
  const schemas: object[] = [ORGANIZATION_SCHEMA, WEBSITE_SCHEMA];

  if (includeService) schemas.push(SERVICE_SCHEMA);
  if (includeFaq) schemas.push(FAQ_SCHEMA);
  if (includeHowTo) schemas.push(HOWTO_SCHEMA);
  if (includeLocalBusiness) schemas.push(LOCAL_BUSINESS_SCHEMA);

  if (breadcrumbs && breadcrumbs.length > 0) {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbs.map((bc, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: bc.name,
        item: bc.url,
      })),
    });
  }

  if (customSchemas) {
    schemas.push(...customSchemas);
  }

  return (
    <>
      {schemas.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}

export { FAQ_ITEMS };
